import type { GAEvent } from "../types/ga";

/**
 * Normalizes a string to lowercase and trims whitespace
 * Used to ensure consistent data in GA events
 */
export const normalizeString = (str?: string | null): string | null => {
  if (!str) return null;
  return str.toLowerCase().trim();
};

/**
 * Gets the current page location
 * Safe for SSR - returns empty string if window is not available
 */
export const getCurrentPageLocation = (): string => {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.href;
};

/**
 * Sends a typed event to Google Analytics via dataLayer
 *
 * @param event - Typed GA4 event object with event name and parameters
 *
 * @example
 * gaTracking({
 *   event: "link_click",
 *   event_parameters: {
 *     page_location: window.location.href,
 *     link_text: "Read more",
 *     link_url: "/article",
 *     link_type: "teaser"
 *   }
 * });
 */
export const gaTracking = (event: GAEvent): void => {
  if (typeof window === "undefined") {
    return;
  }

  if (typeof window.dataLayer === "undefined") {
    window.dataLayer = [];
  }

  window.dataLayer.push(event);
};
